/**
 * Converts image file names to local image paths
 * @param {string|string[]} imageNames - Single image name or array of image names
 * @returns {string|string[]} - Single path or array of paths
 */
export const getImagePath = (imageNames) => {
  if (!imageNames) {
    return '/images/yachts/default-yacht.jpg';
  }
  
  if (Array.isArray(imageNames)) {
    if (imageNames.length === 0) {
      return '/images/yachts/default-yacht.jpg';
    }
    return imageNames.map(name => {
      // If it's already a full URL or path starting with /, return as is
      if (name.startsWith('http') || name.startsWith('/')) {
        return name;
      }
      // Otherwise, treat it as a local file name
      return `/images/yachts/${name}`;
    });
  }
  
  // Single image name
  if (imageNames.startsWith('http') || imageNames.startsWith('/')) {
    return imageNames;
  }
  
  return `/images/yachts/${imageNames}`;
};

/**
 * Gets the first image path from an array of image names
 * @param {string[]} imageNames - Array of image names
 * @returns {string} - Path to the first image
 */
export const getFirstImagePath = (imageNames) => {
  if (!imageNames || !Array.isArray(imageNames) || imageNames.length === 0) {
    return '/images/yachts/default-yacht.jpg';
  }
  
  const firstImage = imageNames[0];
  if (firstImage.startsWith('http') || firstImage.startsWith('/')) {
    return firstImage;
  }
  
  return `/images/yachts/${firstImage}`;
};

